import { SelectOptionType } from 'components/atoms/Select/Select'

export const FUNCTIONS_TEMPLATES = {
  CANDY: 'Candy',
  CANDY3: 'Candy MultiWash',
  CANDY3_CENEO: 'Candy MultiWash V2',
  CANDY4: 'Candy 4'
}

export const functionTemplatesOptions: SelectOptionType[] = [
  { label: FUNCTIONS_TEMPLATES.CANDY, value: FUNCTIONS_TEMPLATES.CANDY },
  { label: FUNCTIONS_TEMPLATES.CANDY3, value: FUNCTIONS_TEMPLATES.CANDY3 },
  {
    label: FUNCTIONS_TEMPLATES.CANDY3_CENEO,
    value: FUNCTIONS_TEMPLATES.CANDY3_CENEO
  },
  // System value Candy 4; user-facing label Candy 2
  { label: 'Candy 2', value: FUNCTIONS_TEMPLATES.CANDY4 }
]

/** Candy MultiWash V2 is only offered for Poland; abroad markets use v1 (Candy / Candy MultiWash). */
export const isCandyMultiWashV2AllowedForCountry = (
  country: string | undefined
): boolean => country === 'PL'

export const getCandyFunctionTemplateOptions = (
  country: string | undefined
): SelectOptionType[] => {
  if (isCandyMultiWashV2AllowedForCountry(country)) {
    return functionTemplatesOptions
  }

  return functionTemplatesOptions.filter(
    opt => opt.value !== FUNCTIONS_TEMPLATES.CANDY3_CENEO
  )
}

export const CANDY4_FULL_FUNCTION_INDEXES = [0, 1, 6, 7, 12, 13] as const

/** Candy 4 Euro — color card backgrounds keyed by 0-based function index. */
export const CANDY4_COLOR_FUNCTION_COLORS: Readonly<Record<number, string>> = {
  2: '#2a5f5f',
  3: '#4F5773',
  4: '#595766',
  5: '#3f5c73',
  8: '#2a5f5f',
  9: '#4F5773',
  10: '#595766',
  11: '#3f5c73',
  14: '#2a5f5f',
  15: '#4F5773'
}

export const CANDY_HIGHLIGHT_INDEXES = {
  [FUNCTIONS_TEMPLATES.CANDY]: [0, 5, 10, 15],
  [FUNCTIONS_TEMPLATES.CANDY3]: [0, 1, 2, 5, 8, 11, 14, 15],
  [FUNCTIONS_TEMPLATES.CANDY3_CENEO]: [2, 6, 9, 13],
  [FUNCTIONS_TEMPLATES.CANDY4]: [...CANDY4_FULL_FUNCTION_INDEXES]
}

/** Same layout highlights as Candy MultiWash — used for Haier card template "Haier 2". */
export const HAIER2_HIGHLIGHT_INDEXES = [
  0, 1, 4, 5, 10, 11, 14, 15
] as const
